export const folderStructure = {
    id: 1,
    isFolder: true,
    name: 'Root',
    items: []
}